// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"116":"333ca60c","932":"5b2c03cd"}[chunkId] + ".css";
};